export default __webpack_public_path__ + "static/media/Meet DocJenFit.f6c9f6c9.png";